import {Routes} from '@angular/router';
import {InitComponent} from './features/init/init.component';
import {LandingComponent} from './features/landing/landing.component';
import {VerifyCodeComponent} from './features/verify-code/verify-code.component';
import {SubscriptionComponent} from './features/subscription/subscription.component';
import {SummaryComponent} from './features/summary/summary.component';
import {InstituteInformationComponent} from './features/institute-information/institute-information.component';
import {ThankYouComponent} from './features/thank-you/thank-you.component';

export const routes: Routes = [
  {
    path: '',
    component: InitComponent
  },
  {
    path: 'landing',
    component: LandingComponent
  },
  {
    path: 'verify-code',
    component: VerifyCodeComponent
  },
  {
    path: 'institute',
    component: InstituteInformationComponent
  },
  {
    path: 'subscription',
    component: SubscriptionComponent
  },
  {
    path: 'summary',
    component: SummaryComponent
  },
  {
    path: 'thank-you',
    component: ThankYouComponent
  }
];
